// Just a mock data

export var constantRoutes = [{
  path: '/redirect',
  component: 'layout/Layout',
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: 'views/redirect/index'
  }]
}, {
  path: '/login',
  component: 'views/login/index',
  hidden: true
}, {
  path: '/auth-redirect',
  component: 'views/login/auth-redirect',
  hidden: true
}, {
  path: '/404',
  component: 'views/error-page/404',
  hidden: true
}, {
  path: '/401',
  component: 'views/error-page/401',
  hidden: true
}, {
  path: '',
  component: 'layout/Layout',
  redirect: 'dashboard',
  children: [{
    path: 'dashboard',
    component: 'views/dashboard/index',
    name: 'Dashboard',
    meta: {
      title: 'Dashboard',
      icon: 'dashboard',
      affix: true
    }
  }]
}];
export var asyncRoutes = [{
  path: '/i18n',
  component: 'layout/Layout',
  children: [{
    path: 'index',
    component: 'views/i18n-demo/index',
    name: 'I18n',
    meta: {
      title: 'I18n',
      icon: 'international'
    }
  }]
}, {
  path: 'external-link',
  component: 'layout/Layout',
  children: [{
    path: 'https://github.com/PanJiaChen/vue-element-admin',
    meta: {
      title: 'External Link',
      icon: 'link'
    }
  }]
}, {
  path: '*',
  redirect: '/404',
  hidden: true
}];